module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image2-b58257b0362e5440425e606da787f288.png";